import React  , { useRef ,  useState , useEffect  , useCallback , forwardRef , useContext  } from 'react';
import AuthenticationLayout from 'js/components/page-components/AuthenticationLayout.js';
import Button from 'js/components/ui/input/Button.js';
import TextField from '@mui/material/TextField';
import   'scss/pages/LoginPage.scss';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import MailIcon from '@mui/icons-material/Mail';
import VisibilityOffSharpIcon from '@mui/icons-material/VisibilityOffSharp';
import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
import Alert from '@mui/material/Alert';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import DAuth from 'js/Services/Auth/AuthAdapter/DAuth.js';
import AppContext from  'js/Contexts/App.js';
import Layout from 'js/components/page-components/Layout.js';

import Page from 'js/components/page-components/Page.js';


const PageCouldNotBeLoaded = () => {

    const appContext = useContext(AppContext);





    return (
        <Layout>
          <Page>
                <div className="contentHolder" style={{ padding: '40px' , marginTop: '50px'}}>
                     <Alert severity="warning">Page could not be loaded. If you are offline the page will automatically reload once you are back online</Alert>
                </div>
                </Page>
        </Layout>
    );
};

export default PageCouldNotBeLoaded;
